import { motion } from "framer-motion";
import { GlassCard } from "./GlassCard";
import { TrendingUp, Calendar, Award, Target } from "lucide-react";

const MOOD_EMOJIS = {
  very_happy: "😄",
  happy: "🙂",
  neutral: "😐",
  sad: "😔",
  very_sad: "😢",
  angry: "😡",
  anxious: "😰",
  tired: "😴",
  in_love: "😍",
  sick: "🤒",
  surprised: "😲",
  relaxed: "😌",
  sporty: "💪",
  forgiven: "🙏",
};

export const StatsPanel = ({ stats, loading }) => {
  if (loading) {
    return (
      <GlassCard className="p-6 h-full">
        <div className="space-y-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="skeleton h-16 rounded-lg" />
          ))}
        </div>
      </GlassCard>
    );
  }

  const statItems = [
    {
      icon: Calendar,
      label: "Total Registros",
      value: stats?.total_entries || 0,
      color: "text-neon-cyan",
      bgColor: "bg-neon-cyan/10",
      borderColor: "border-neon-cyan/30",
    },
    {
      icon: TrendingUp,
      label: "Promedio",
      value: stats?.average_mood?.toFixed(1) || "0.0",
      suffix: "/5",
      color: "text-neon-purple",
      bgColor: "bg-neon-purple/10",
      borderColor: "border-neon-purple/30",
    },
    {
      icon: Award,
      label: "Racha Actual",
      value: stats?.streak_days || 0,
      suffix: " días",
      color: "text-neon-green",
      bgColor: "bg-neon-green/10",
      borderColor: "border-neon-green/30",
    },
    {
      icon: Target,
      label: "Más Frecuente",
      value: stats?.most_common_mood ? MOOD_EMOJIS[stats.most_common_mood] : "—",
      isEmoji: true,
      color: "text-neon-yellow",
      bgColor: "bg-neon-yellow/10",
      borderColor: "border-neon-yellow/30",
    },
  ];

  return (
    <GlassCard className="p-6 xl:p-8 h-full">
      <h2 className="heading-cyber text-xl xl:text-2xl mb-4">Resumen</h2>
      <div className="space-y-3 xl:space-y-4">
        {statItems.map((item, index) => (
          <motion.div
            key={item.label}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            className={`stat-card flex items-center gap-3 xl:gap-4 p-3 xl:p-4 rounded-lg ${item.bgColor} border ${item.borderColor}`}
            data-testid={`stat-${item.label.toLowerCase().replace(" ", "-")}`}
          >
            <div className={`p-2 xl:p-3 rounded-lg ${item.bgColor}`}>
              <item.icon className={`w-5 h-5 xl:w-6 xl:h-6 ${item.color}`} />
            </div>
            <div className="flex-1">
              <p className="font-rajdhani text-xs xl:text-sm uppercase tracking-wider text-slate-400">
                {item.label}
              </p>
              <p className={`font-orbitron text-xl xl:text-2xl ${item.color}`}>
                {item.isEmoji ? (
                  <span className="text-2xl xl:text-3xl">{item.value}</span>
                ) : (
                  <>
                    {item.value}
                    {item.suffix && <span className="text-sm xl:text-base text-slate-400">{item.suffix}</span>}
                  </>
                )}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </GlassCard>
  );
};
